(() => {
  'use strict';

  const DATA_URL = window.RF_POSTCODE_SUBURBS_URL || '';
  let postcodeMapPromise;
  const updateSequence = new WeakMap();

  function loadMap() {
    if (!DATA_URL) return Promise.resolve({});
    if (!postcodeMapPromise) {
      postcodeMapPromise = fetch(DATA_URL, { credentials: 'same-origin' })
        .then((response) => {
          if (!response.ok) throw new Error('Failed to load postcode data');
          return response.json();
        })
        .catch(() => ({}));
    }
    return postcodeMapPromise;
  }

  function normalisePostcode(value) {
    return String(value || '').replace(/\D/g, '').slice(0, 4);
  }

  function createOption(value, label) {
    const option = document.createElement('option');
    option.value = value;
    option.textContent = label;
    return option;
  }

  async function updateSuburb(postcodeInput, suburbSelect) {
    const sequence = (updateSequence.get(suburbSelect) || 0) + 1;
    updateSequence.set(suburbSelect, sequence);
    const postcode = normalisePostcode(postcodeInput.value);
    if (postcodeInput.value !== postcode) postcodeInput.value = postcode;

    suburbSelect.innerHTML = '';
    suburbSelect.append(createOption('', postcode.length === 4 ? 'Select suburb' : 'Enter postcode first'));
    suburbSelect.disabled = postcode.length !== 4;

    if (postcode.length !== 4) return;

    const map = await loadMap();
    if (updateSequence.get(suburbSelect) !== sequence) return;
    if (normalisePostcode(postcodeInput.value) !== postcode) return;
    const matches = Array.isArray(map[postcode]) ? map[postcode] : [];

    matches.forEach((item) => {
      const suburb = typeof item === 'string' ? item : item.suburb;
      const state = typeof item === 'string' ? '' : item.state;
      if (!suburb) return;
      suburbSelect.append(createOption(suburb, state ? `${suburb} (${state})` : suburb));
    });

    suburbSelect.append(createOption('Other / Suburb not listed', 'Other / Suburb not listed'));
    suburbSelect.disabled = false;

    if (matches.length === 1) {
      const only = typeof matches[0] === 'string' ? matches[0] : matches[0].suburb;
      if (only) suburbSelect.value = only;
    }
  }

  function bindForm(form) {
    if (form.dataset.rfPostcodeSuburbBound === 'true') return;
    const postcodeInput = form.querySelector('[name="contact[Postcode]"]');
    const suburbSelect = form.querySelector('[name="contact[Suburb]"]');
    if (!postcodeInput || !suburbSelect) return;

    form.dataset.rfPostcodeSuburbBound = 'true';
    const refresh = () => void updateSuburb(postcodeInput, suburbSelect);
    postcodeInput.addEventListener('input', refresh);
    postcodeInput.addEventListener('change', refresh);
    refresh();
  }

  function initialise(root = document) {
    root.querySelectorAll('form').forEach(bindForm);
  }

  document.addEventListener('DOMContentLoaded', () => initialise());
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();